"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PureSubscriptionSwitches = void 0;
var _react = require("react");
var _reactI18next = require("react-i18next");
var _propTypes = require("prop-types");
var _reactRedux = require("react-redux");
var _SectionHeader = _interopRequireDefault(require("../../components/SectionHeader"));
var _SubscriptionSwitchesList = _interopRequireDefault(require("../../components/SubscriptionSwitchesList"));
var _MyAccountError = _interopRequireDefault(require("../../components/MyAccountError"));
var _PlanDetailsPopupManager = _interopRequireDefault(require("../../components/PlanDetailsPopupManager"));
var _popupSlice = require("../../redux/popupSlice");
var _innerPopupReducer = require("../../redux/innerPopupReducer");
var _offersSlice = require("../../redux/offersSlice");
var _planDetailsSlice = require("../../redux/planDetailsSlice");
var _SubscriptionSwitchesStyled = require("./SubscriptionSwitchesStyled");
var _jsxRuntime = require("react/jsx-runtime");
const SubscriptionSwitches = _ref => {
  let {
    offerId,
    onCancel,
    toOfferId,
    onSwitchSuccess,
    onSwitchError
  } = _ref;
  const {
    isOpen: isPopupOpen
  } = (0, _reactRedux.useSelector)(state => state.popupManager);
  const {
    data: switchSettings
  } = (0, _reactRedux.useSelector)(store => store.plan.switchSettings);
  const {
    offers
  } = (0, _reactRedux.useSelector)(state => state.offers);
  const [switchSettingsError, setSwitchSettingsError] = (0, _react.useState)(false);
  const dispatch = (0, _reactRedux.useDispatch)();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const getAndSaveSwitchSettings = async selectedSubscriptionData => {
    await dispatch((0, _planDetailsSlice.fetchAvailableSwitches)([selectedSubscriptionData]));
  };
  const fetchOffersData = async () => {
    const customerOffers = await dispatch((0, _planDetailsSlice.fetchCustomerOffers)()).unwrap();
    const activeSubscriptions = customerOffers.filter(_ref2 => {
      let {
        status,
        offerType
      } = _ref2;
      return status === 'active' && offerType === 'S';
    });
    const offersWithPendingSwitches = activeSubscriptions.filter(_ref3 => {
      let {
        pendingSwitchId
      } = _ref3;
      return pendingSwitchId;
    });
    dispatch((0, _planDetailsSlice.fetchPendingSwitches)(offersWithPendingSwitches));
    const selectedSubscriptionData = activeSubscriptions.find(offer => offer.offerId === offerId);
    if (!selectedSubscriptionData) {
      setSwitchSettingsError(true);
      return;
    }
    dispatch((0, _planDetailsSlice.setOfferToSwitch)(selectedSubscriptionData));
    getAndSaveSwitchSettings(selectedSubscriptionData);
  };
  const immediatelyOpenSwitchPopupIfPossible = () => {
    if (offerId && toOfferId) {
      var _switchSettings$offer;
      const toOfferData = (_switchSettings$offer = switchSettings[offerId]) === null || _switchSettings$offer === void 0 ? void 0 : _switchSettings$offer.available.find(item => item.toOfferId === toOfferId);
      if (!toOfferData) return;
      dispatch((0, _popupSlice.showPopup)({
        type: _innerPopupReducer.POPUP_TYPES.switchPlan,
        data: {
          offerData: {
            ...toOfferData
          }
        }
      }));
    }
  };
  (0, _react.useEffect)(() => {
    if (offerId) {
      fetchOffersData();
    }
    if (isPopupOpen) {
      dispatch((0, _popupSlice.hidePopup)());
      dispatch((0, _planDetailsSlice.updateList)());
    }
    if (offers.length === 0) dispatch((0, _offersSlice.fetchOffers)());
  }, []);
  (0, _react.useEffect)(() => {
    if (offerId && !switchSettings[offerId]) {
      fetchOffersData();
    }
  }, [offerId]);
  (0, _react.useEffect)(() => {
    immediatelyOpenSwitchPopupIfPossible();
  }, [switchSettings]);
  if (switchSettingsError) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountError.default, {
      generalError: true
    });
  }
  if (isPopupOpen) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PlanDetailsPopupManager.default, {
    onCancel: onCancel,
    onSwitchSuccess: onSwitchSuccess,
    onSwitchError: onSwitchError
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_SubscriptionSwitchesStyled.WrapStyled, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionHeader.default, {
      children: t('subscription-switches.change-plan', 'Change Plan')
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionSwitchesList.default, {})]
  });
};
exports.PureSubscriptionSwitches = SubscriptionSwitches;
SubscriptionSwitches.propTypes = {
  offerId: _propTypes.PropTypes.string.isRequired,
  onCancel: _propTypes.PropTypes.func,
  onSwitchSuccess: _propTypes.PropTypes.func,
  onSwitchError: _propTypes.PropTypes.func,
  toOfferId: _propTypes.PropTypes.string
};
SubscriptionSwitches.defaultProps = {
  onCancel: null,
  onSwitchSuccess: null,
  onSwitchError: null,
  toOfferId: null
};
var _default = exports.default = SubscriptionSwitches;